import createIcon from '../../icons/createIcon';

const IconLoadingCircle = createIcon('IconLoadingCircle', '0 0 64 64', [
    [
        'g',
        {
            'clip-path': 'url(#paint0_angular_5026_1202_clip_path)',
            'data-figma-skip-parse': 'true',
            key: 'a0e27f'
        },
        [
            {
                name: 'g',
                type: 'element',
                value: '',
                parent: null,
                attributes: {
                    transform: 'matrix(0.024 5.95646e-05 -5.95646e-05 0.024 32 32)',
                    key: '128776'
                },
                children: [
                    {
                        name: 'foreignObject',
                        type: 'element',
                        value: '',
                        parent: null,
                        attributes: {
                            x: '-1086.02',
                            y: '-1086.02',
                            width: '2172.03',
                            height: '2172.03',
                            key: 'bebd40'
                        },
                        children: [
                            {
                                name: 'div',
                                type: 'element',
                                value: '',
                                parent: null,
                                attributes: {
                                    xmlns: 'http://www.w3.org/1999/xhtml',
                                    style: 'background:conic-gradient(from 90deg,rgba(255, 255, 255, 1) 0deg,rgba(255, 255, 255, 0.05) 269.818deg,rgba(255, 255, 255, 0) 315deg,rgba(255, 255, 255, 1) 360deg);height:100%;width:100%;opacity:1',
                                    key: 'ef0c63'
                                },
                                children: []
                            }
                        ]
                    }
                ]
            }
        ]
    ],
    [
        'path',
        {
            d: 'M18.6663 12.0452C23.2828 8.96053 28.8263 7.57149 34.3518 8.11549C39.8776 8.65974 45.0447 11.1033 48.971 15.0296L43.3147 20.6858C40.6972 18.0683 37.2525 16.4393 33.5686 16.0764C29.8848 15.7136 26.1894 16.641 23.1116 18.6975C20.0338 20.754 17.7643 23.8135 16.6897 27.3557C15.6152 30.898 15.8024 34.7034 17.219 38.1233C18.6356 41.543 21.1929 44.3667 24.4573 46.1116C27.7217 47.8565 31.4909 48.4156 35.1213 47.6936C38.7519 46.9715 42.0211 45.0121 44.3694 42.1507C46.7175 39.2893 48.0003 35.7018 48.0003 32.0003H56.0003C56.0003 37.5525 54.0751 42.9328 50.553 47.2249C47.0305 51.517 42.1277 54.4561 36.6819 55.5393C31.2362 56.6224 25.5825 55.7836 20.6858 53.1663C15.7893 50.5488 11.9512 46.3134 9.82643 41.1839C7.70194 36.0543 7.42178 30.3465 9.03346 25.0335C10.6452 19.7201 14.0497 15.13 18.6663 12.0452Z',
            'data-figma-gradient-fill':
                '{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.050000000745058060},&#34;position&#34;:0.74949485063552856},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:0.8750}],&#34;stopsVar&#34;:[],&#34;transform&#34;:{&#34;m00&#34;:47.999988555908203,&#34;m01&#34;:-0.11912918835878372,&#34;m02&#34;:8.0595760345458984,&#34;m10&#34;:0.11912916600704193,&#34;m11&#34;:47.999988555908203,&#34;m12&#34;:7.9404435157775879},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}',
            key: '8b7413'
        },
        []
    ],
    [
        'defs',
        {
            key: 'd72f7e'
        },
        [
            {
                name: 'clipPath',
                type: 'element',
                value: '',
                parent: null,
                attributes: {
                    id: 'paint0_angular_5026_1202_clip_path',
                    key: 'a9d1d6'
                },
                children: [
                    {
                        name: 'path',
                        type: 'element',
                        value: '',
                        parent: null,
                        attributes: {
                            d: 'M18.6663 12.0452C23.2828 8.96053 28.8263 7.57149 34.3518 8.11549C39.8776 8.65974 45.0447 11.1033 48.971 15.0296L43.3147 20.6858C40.6972 18.0683 37.2525 16.4393 33.5686 16.0764C29.8848 15.7136 26.1894 16.641 23.1116 18.6975C20.0338 20.754 17.7643 23.8135 16.6897 27.3557C15.6152 30.898 15.8024 34.7034 17.219 38.1233C18.6356 41.543 21.1929 44.3667 24.4573 46.1116C27.7217 47.8565 31.4909 48.4156 35.1213 47.6936C38.7519 46.9715 42.0211 45.0121 44.3694 42.1507C46.7175 39.2893 48.0003 35.7018 48.0003 32.0003H56.0003C56.0003 37.5525 54.0751 42.9328 50.553 47.2249C47.0305 51.517 42.1277 54.4561 36.6819 55.5393C31.2362 56.6224 25.5825 55.7836 20.6858 53.1663C15.7893 50.5488 11.9512 46.3134 9.82643 41.1839C7.70194 36.0543 7.42178 30.3465 9.03346 25.0335C10.6452 19.7201 14.0497 15.13 18.6663 12.0452Z',
                            key: 'ad9fb2'
                        },
                        children: []
                    }
                ]
            }
        ]
    ]
]);

export { IconLoadingCircle };
